import http from '@api'
import getAgentRoute from '@plugin/searchRoute/modules/agent'
import { idsToSuburbs } from '@plugin/searchRoute/utils'
import { assign, get } from 'lodash-es'

export async function getMetaData(slug, totals) {

  const agentRoute = getAgentRoute()
  agentRoute.fromSlug(slug)
  const { regionId, districtId, suburbId } = agentRoute.toQuery()

  return await http.get('enum/meta', {
    route: 'saleAgent',
    num: totals,
    regionIds: regionId,
    districtIds: districtId,
    suburbIds: suburbId
  })
}

export async function getAgentListData(typeId, slug, filter, pageSize) {
  const params = getParams(typeId, slug, filter, pageSize)
  const data = await http.get('agents', params)
  // const d = sortBy(data, item => !(item.premium || item.feature || item.bronze))
  return [
    data,
    get(data, 'headers.x-total-count')
  ]
}

export async function getSuburbs(slug) {
  const agentRoute = getAgentRoute()
  const { regionId, districtId, suburbId } = agentRoute.fromSlug(slug).toQuery()
  return await idsToSuburbs({ regionId, districtId, suburbId })
}

export function getFilterParams(slug, filter, typeId) {
  const agentRoute = getAgentRoute()
  agentRoute.fromSlug(slug)
  const { regionId, districtId, suburbId } = agentRoute.toQuery()
  return assign({ regionId, districtId, suburbId, filter, typeId })
}

export function getParams(typeId, slug, filter, pageSize) {
  const agentRoute = getAgentRoute()
  agentRoute.fromSlug(slug)
  return assign({ typeId }, filter ? { filter } : undefined, agentRoute.toQuery(pageSize))
}